export default __webpack_public_path__ + "static/media/prodotti-dark.8f1d8ce4.svg";